<template>
  <div class="main-table">
    <table class="routes-table">
      <thead>
        <tr>
          <th>Маршрут</th>
          <th>Ставка без НДС</th>
          <th>Ставка с НДС</th>
          <th>Корректировка без НДС</th>
          <th>Корректировка с НДС</th>
          <th>С даты</th>
          <th>До даты</th>
          <th >Статус</th>
          <th class="action-column">Действия</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="route in routes" :key="route.id">
          <td>{{ route.departure_city }} - {{ route.destination_city }}</td>
          <td>
            <div v-if="editingRouteId === route.id">
              <input 
              type="number" 
              step="1000" 
              min="0" 
              v-model="route.bid"/>
            </div>
            <div v-else>{{ route.bid }}</div>
          </td>
          <td>
            <div v-if="editingRouteId === route.id">
              <input 
              type="number" 
              step="1000" 
              min="0" 
              v-model="route.bid_tax"/>
            </div>
            <div v-else>{{ route.bid_tax }}</div>
          </td>
          <td>
            <input
              type="number"
              step="1000"
              min="0"
              v-model.number="route.changed_rate_bid"
              :disabled="editingRouteId == route.id"
            />
          </td>
          <td>
            <input
              type="number"
              step="1000"
              min="0"
              v-model.number="route.changed_rate_bid_tax"
              :disabled="editingRouteId == route.id"
            />
          </td>
          <td>
            <input
              type="datetime-local"
              v-model="route.from_dt"
              :disabled="editingRouteId == route.id"
            />
          </td>
          <td>
            <input
              type="datetime-local"
              v-model="route.before_dt"
              :disabled="editingRouteId == route.id"
            />
          </td>
          <td>
            <span :class="getStatusClass(route.status)" >
              <div class="status-item"><p>{{ getStatusText(route.status) }}</p></div>
            </span>
          </td>
          <td>
            <div v-if="editingRouteId === route.id">
              <font-awesome-icon
                title="Сохранить"
                icon="fa-solid fa-save"
                class="icon save"
                @click="saveRoute(route)"
              />
              <font-awesome-icon
                title="Отмена"
                icon="fa-solid fa-times"
                class="icon trash"
                @click="cancelEditing()"
              />
              <font-awesome-icon 
              title="Удалить маршрут" 
              icon="fa-solid fa-trash" 
              class="icon trash" 
              @click="deleteRoute(route.id)" />
            </div>
            <div v-else>
              <font-awesome-icon 
              title="Запустить выставление"
              v-if="route.status != 'open'" 
              icon="fa-solid fa-play" 
              class="icon play"
              @click="toggleStatus(route,'update')"/>

              <font-awesome-icon 
              v-else
              title="Остановить выставление"  
              icon="fa-solid fa-stop" 
              class="icon stop"
              @click="toggleStatus(route,'delete')"/>

              <font-awesome-icon 
              title="Редактировать" 
              icon="fa-solid fa-pen-to-square" 
              class="icon" 
              @click="editRoute(route.id)"
              />

              
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { defineComponent, toRefs, ref } from "vue";

export default defineComponent({
  props: {
    routes: {
      type: Array,
      required: true,
    },
  },
  emits: ['delete', 'update', 'toggleStatus'],
  setup(props, { emit }) {
    const editingRouteId = ref(null); // Отслеживает редактируемый маршрут

    const editRoute = (id) => {
      editingRouteId.value = id;
    };

    const saveRoute = (route) => {
      updateRoute(route);
      editingRouteId.value = null; // Завершаем редактирование
    };

    const cancelEditing = () => {
      editingRouteId.value = null; // Отменяем редактирование
    };

    const { routes } = toRefs(props);

    const deleteRoute = (id) => {
      emit("deleteRoute", id);
      editingRouteId.value = null; // Завершаем редактирование
    };

    const updateRoute = (route) => {
      emit("updateRoute", {routeId:route.id, route});
    };

    const toggleStatus = (route,status) => {
      let newStatus;
      if (route.status === 'open') {
        newStatus = 'delete';
        emit("toggleStatus", { ids: [route.id,], status });
      } else if (route.status === 'close') {
        newStatus = 'update';
        emit("toggleStatus", { routes: [route,], status });
      }
    };

    const getStatusClass = (status) => {
      switch(status) {
        case 'open':
          return 'status-active';
        case 'close':
        case null:
          return 'status-inactive';
        default:
          return 'status-default';
      }
    };

    const getStatusText = (status) => {
      switch(status) {
        case 'open':
          return 'Открыт';
        case 'close':
        case null:
          return 'Закрыт';
        default:
          return 'Обработка...';
      }
    };


    return {
      editingRouteId,
      editRoute,
      saveRoute,
      cancelEditing,
      getStatusText,
      getStatusClass,
      routes,
      deleteRoute,
      updateRoute,
      toggleStatus,
    };
  },
});
</script>

<style scoped>
.main-table{
  padding: 15px;
}

.routes-table {
  width: 100%;
  border-collapse: collapse;
}

.routes-table th,
.routes-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  font-size: 14px;
}

.action-column{
  min-width: 110px;
  max-width: 110px;
}
.routes-table th {
  background-color: #f8f9fa;
  font-weight: bold;
}

.routes-table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

.routes-table tbody tr:hover {
  background-color: #f1f1f1;
}

.routes-table input {
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

.routes-table input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.routes-table .status-item {
  text-align: center;
  padding: 5px;
  border: 1px solid;
  border-radius: 5px;
}

.routes-table .status-active {
  color: rgb(40, 167, 69);
  font-weight: bold;
}

.routes-table .status-inactive {
  color: rgb(220, 53, 69);
  font-weight: bold;
}

.routes-table .toggle-status-button {
  color: #007bff;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  margin-right: 10px;
}

.routes-table .toggle-status-button:hover {
  text-decoration: underline;
}

.routes-table .delete-button {
  color: #dc3545;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

.routes-table .delete-button:hover {
  text-decoration: underline;
}

.status-border{
  text-align: center;
  padding: 5px;
  border: 1px solid rgba(209, 48, 48, 0.5);
  border-radius: 5px;
}

.icon{
  width: 15px;
  height: 15px;
  margin: 0px 5px;
  padding: 2px;
  border-radius: 5px;
}

.save{
  color: rgba(143, 195, 157, 1);
}

.play {
  background-color: rgba(143, 195, 157, 1);
}

.stop{
  background-color: rgba(248, 199, 38, 1);
}

.trash{
  color: rgba(248, 38, 38, 0.8);
}

</style>